import { Component } from '@angular/core';
import { ICONS } from 'src/app/core/constants/icons';
import { ROUTES } from 'src/app/core/constants/routes';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss']
})
export class VerificationComponent {
  LOGO = ICONS.LOGO;
  LOGIN_ROUTE = ROUTES.LOGIN;
}
